import { deviceType } from '@/utils/common'
import CreatePassword from './common/createPassword.vue'
import ForgetPassword from './common/forgetPassword.vue'
import MobileRanting from './mobile/rating.vue'
import PcRating from './pc/rating.vue'
import MobileInterviewRating from './mobile/interviewRating.vue'
import PcInterviewRating from './pc/interviewRating.vue'
import PcInterviewInvitation from './pc/interviewInvitation.vue'
import MobileInterviewInvitation from './mobile/interviewInvitation.vue'
import MobileLogin from './mobile/login.vue'
import PcLogin from './pc/login.vue'
import Index from './index.vue'
import { ACCOUNT_TYPE, HM_MOBILE_DASHBOARD_PATH, HM_MOBILE_INTERVIEW_PATH, HM_PC_DASHBOARD_PATH, HM_PC_INTERVIEW_PATH } from '@/constant/common'

const basePath = '/v-admin/hm'
const ExternalRedirect = { render: h => h() }

function redirectToNewHmPage (targetPath) {
  return (to, from, next) => {
    const routeSuffix = to.fullPath.slice(to.path.length)
    next(false)
    window.location.replace(`${targetPath}${routeSuffix}`)
  }
}

const loginRoute = {
  name: 'loginPage',
  path: `${basePath}/login`,
  redirect: (to) => {
    const query = { ...to.query }
    if (query.backUrl) {
      query.back = query.backUrl
      delete query.backUrl
    }
    return { path: `/passport/${ACCOUNT_TYPE.HIRING_MANAGER}/login`, query }
  },
  component: deviceType.isPc ? PcLogin : MobileLogin,
  meta: {
    noAuth: true,
    titleI18nKey: 'hm.dashboard.title'
  }
}

const forgetPasswordRoute = {
  name: 'forgetPasswordPage',
  path: `${basePath}/forget-password`,
  redirect: (to) => {
    const query = { ...to.query }
    if (query.backUrl) {
      query.back = query.backUrl
      delete query.backUrl
    }
    return { path: `/passport/${ACCOUNT_TYPE.HIRING_MANAGER}/forget-password`, query }
  },
  component: ForgetPassword,
  meta: {
    titleI18nKey: 'hm.dashboard.title'
  }
}

const createPasswordRoute = {
  name: 'createPasswordPage',
  path: `${basePath}/create-password/:resetCode`,
  redirect: (to) => {
    const query = { ...to.query }
    if (query.backUrl) {
      query.back = query.backUrl
      delete query.backUrl
    }
    return { path: `/passport/${ACCOUNT_TYPE.HIRING_MANAGER}/create-password/${to.params.resetCode}`, query }
  },
  component: CreatePassword,
  meta: {
    titleI18nKey: 'hm.dashboard.title'
  }
}

export { loginRoute, forgetPasswordRoute, createPasswordRoute }

export default {
  name: 'hm-dashboard',
  path: `${basePath}`,
  redirect: `${basePath}/dashboard/interview`,
  component: Index,
  meta: {
    noAuth: true,
    titleI18nKey: 'hm.index.title'
  },
  children: [
    {
      name: 'hmHomePage',
      path: `${basePath}/dashboard`,
      component: ExternalRedirect,
      beforeEnter: redirectToNewHmPage(deviceType.isPc ? HM_PC_DASHBOARD_PATH : HM_MOBILE_DASHBOARD_PATH),
      meta: {
        titleI18nKey: 'hm.tab.dashboard'
      }
    },
    {
      name: 'interviewPage',
      path: `${basePath}/dashboard/interview`,
      component: ExternalRedirect,
      beforeEnter: redirectToNewHmPage(deviceType.isPc ? HM_PC_INTERVIEW_PATH : HM_MOBILE_INTERVIEW_PATH),
      meta: {
        titleI18nKey: 'hm.tab.dashboard'
      }
    },
    loginRoute,
    forgetPasswordRoute,
    createPasswordRoute,
    {
      name: 'ratingPage',
      path: `${basePath}/rating/:inviteCode`,
      component: deviceType.isPc ? PcRating : MobileRanting,
      meta: {
        titleI18nKey: 'hm.dashboard.title'
      }
    },
    {
      name: 'interviewRatingPage',
      path: `${basePath}/interview/:inviteCode`,
      component: deviceType.isPc ? PcInterviewRating : MobileInterviewRating,
      meta: {
        titleI18nKey: 'hm.dashboard.title'
      }
    },
    {
      path: `${basePath}/interview-invitation`,
      component: deviceType.isPc ? PcInterviewInvitation : MobileInterviewInvitation,
      meta: {
        titleI18nKey: 'hm.dashboard.title'
      }
    }
  ]
}
